import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/clinic/assets/images/logo-recoma.png'


const _withScopeId = n => (_pushScopeId("data-v-d29f4a2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forgot-password-page" }
const _hoisted_2 = { class: "forgot-password-form mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo mx-auto",
    src: _imports_0,
    alt: "Logo"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center text-red mt-2"
}
const _hoisted_5 = { class: "py-4 mx-auto" }
const _hoisted_6 = { class: "flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("アカウント名"),
  /*#__PURE__*/_createElementVNode("small", { class: "required pl-2" }, "必須")
], -1))
const _hoisted_8 = { class: "flex flex-column gap-2 my-5" }

import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { ref, reactive, computed } from "vue";
import { default as rules } from "./rules";
import { get, set } from "@vueuse/core";
import * as _ from "lodash";
import { ClinicService } from "../../services";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { ValidateError } from "async-validator/dist-types/interface";
import { ApiForgotPasswordRequest } from "../../typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formForgotPassword = reactive({ email: "" });
const errorMessage = ref("");
const initValidation = computed(() => {
  return useAsyncValidator(formForgotPassword, rules);
});
const validate = async (): Promise<boolean> => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const pass = ref(false);
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);
const onSuccess = () => {
  RouterUtils.goTo(RouterConstants.SIGN_IN_ROUTER_NAME);
};
const onError = (error: any) => {
  errorMessage.value = error.response?.data?.errors;
};
const requestForgotPassword = async () => {
  if (!(await validate())) return;

  await ClinicService.forgotPassword(formForgotPassword as unknown as ApiForgotPasswordRequest, onSuccess, onError);
};
const backToSignIn = () => {
  RouterUtils.goTo(RouterConstants.SIGN_IN_ROUTER_NAME);
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      ((!pass.value && errors.value?.length) || errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_.head(errors.value)?.message || errorMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            modelValue: formForgotPassword.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formForgotPassword.email) = $event)),
            "aria-describedby": "username-help",
            type: "email",
            size: "large",
            name: "email",
            placeholder: "メールアドレス",
            class: _normalizeClass({ 'border-red': errorFields.value?.email?.length }),
            onChange: validate
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "ログイン",
            class: "p-button-lg btn-primary",
            disabled: !pass.value,
            onClick: requestForgotPassword
          }, null, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["back-to-sign-in text-right", { 'has-error': !pass.value || errorMessage.value }])
      }, [
        _createElementVNode("i", {
          onClick: backToSignIn,
          class: "pi pi-arrow-left"
        }, "ログインに戻る")
      ], 2)
    ])
  ]))
}
}

})